import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { add } from 'date-fns';

import { SvbrgIntakeRequestLineItem, SvbrgIntakeRequestLineItemInput } from '@/generated/gql/graphql';
import { coaleseDecimal } from '~/util/number/coaleseDecimal';

import { IntakeRequestLineItem } from './IntakeRequestLineItemStep.schema';

export const gridDataToLineItem = (row: GridValidRowModel, index: number): SvbrgIntakeRequestLineItemInput => {
  return {
    commodityGroupId: row.commodityGroupId,
    description: row.description,
    earlyDeliveryAt: row.earlyDeliveryAt,
    expectedPricePerUnit: row.expectedPricePerUnit ? row.expectedPricePerUnit.toString() : null,
    id: row.id,
    lateDeliveryAt: row.lateDeliveryAt,
    position: row.position ?? '',
    quantity: row.quantity.toString(),
    sequence: index + 1,
    title: row.title,
    unitId: row.unitId,
  };
};

export const toLineItemSchemaData = (lineItems?: SvbrgIntakeRequestLineItem[] | null): IntakeRequestLineItem[] => {
  return (
    lineItems?.map(
      (
        {
          id,
          position,
          title,
          commodityGroupId,
          description,
          earlyDeliveryAt,
          lateDeliveryAt,
          expectedPricePerUnit,
          quantity,
          unitId,
        },
        index,
      ) => {
        return {
          id,
          position,
          title: title ?? '',
          sequence: index + 1,
          commodityGroupId: commodityGroupId ?? '',
          description: description ?? '',
          earlyDeliveryAt: earlyDeliveryAt ? new Date(earlyDeliveryAt) : null,
          lateDeliveryAt: lateDeliveryAt ? new Date(lateDeliveryAt) : add(new Date(), { days: 14 }),
          expectedPricePerUnit: coaleseDecimal(expectedPricePerUnit),
          quantity: coaleseDecimal(quantity),
          unitId: unitId ?? '',
        };
      },
    ) ?? []
  );
};
